import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Suspense } from 'react';
import publicRoutes from './publicRoutes.jsx';
import registrationRoutes from './registrationRoute.jsx';
import userDashboardRoutes from './userDashboardRoutes.jsx';
import settingRoutes from './settingRoutes.jsx';
import cheatsRoutes from './cheatsRoutes.jsx';
import migrationRedirects from './migrationRedirects.jsx';
import AccountPage from '../pages/account/AccountPage.jsx'
import VerifyEmailRequired from '../pages/account/authentication-pages/VerifyEmailRequired.jsx';
import PageNotFound from '../pages/error-pages/PageNotFound.jsx';
import NotAuthorized from '../pages/error-pages/NotAuthorized.jsx';
import FirebaseLinkPages from '../pages/firebase-link-pages/FirebaseLinkPages.jsx';
import DashboardLayout from '../shell/layouts/DashboardLayout.jsx';
import { ProtectedRoute } from '../authentication/ProtectedRoute.jsx';
import { lazyWithRetry } from '../utils/lazyWithRetry.js';
import ChunkErrorBoundary from '../components/ChunkErrorBoundary.jsx';
import RouteErrorPage from '../components/RouteErrorPage.jsx';

const DemoPage = lazyWithRetry(() => import('../pages/demo/DemoPage.jsx'));

const PlaygroundBootstrap = lazyWithRetry(() => import('../playground/PlaygroundBootstrap.jsx'));

// Every top-level route falls back to RouteErrorPage when it throws, rather than the router's own dead-end error
// screen. A route that brings its own errorElement keeps it.
const withErrorPage = (routes) => routes.map((route) => (route.errorElement ? route : { ...route, errorElement: <RouteErrorPage /> }));

const router = createBrowserRouter(withErrorPage([
    {
        path: '/',
        element: <Navigate to="/home" replace />,
    },
    {
        path: '/playground',
        element: (
            <ChunkErrorBoundary>
                <Suspense fallback={<div className="loading">Loading...</div>}>
                    <PlaygroundBootstrap />
                </Suspense>
            </ChunkErrorBoundary>
        ),
    },
    ...publicRoutes,
    ...registrationRoutes,
    ...userDashboardRoutes,
    ...settingRoutes,
    ...cheatsRoutes,
    ...migrationRedirects,
    {
        path: 'demo',
        element: (
            <ProtectedRoute>
                <DashboardLayout dashboardType="demo" />
            </ProtectedRoute>
        ),
        children: [
            {
                path: '',
                element: <DemoPage />,
            },
        ],
    },
    {
        path: '/account',
        element: <AccountPage />,
    },
    {
        // Outside every guarded tree — the email gates redirect here, so guarding it would loop.
        path: '/verify-email',
        element: <VerifyEmailRequired />,
    },
    {
        path: '/not-authorized',
        element: <NotAuthorized />,
    },
    {
        path: '/authentication-link',
        element: <FirebaseLinkPages />,
    },
    {
        path: '*',
        element: <PageNotFound />,
    },
]));

export default router;
